module.exports = __webpack_public_path__ + "img/banner-solgen.abd2209d.png";